import React, { useState, useEffect } from 'react';
import {
     useDispatch, useSelector,Spin
} from '../../AntComponent';
import { getMilestone } from '../../../store/actions/project-management/ProjectAction';
import { Gantt, ViewMode } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";

export default function GanttChart (props){
    const dispatch = useDispatch();
    const [mileData, setMileData] = useState([]);
    const { milestoneInfo, loading7,prjdetailInfo } = useSelector((state) => state.project);
    const currentDate = new Date();
    const [viewMode, setViewMode] = useState(ViewMode.Week);
    const [tasksData, setTasksData] = useState([]);

    let columnWidth = 60;
    if (viewMode === ViewMode.Month) {
      columnWidth = 200;
    } else if (viewMode === ViewMode.Week) {
      columnWidth = 100;
    } else if (viewMode === ViewMode.Year) {
        columnWidth = 380;
    }
    else {
      columnWidth = 60;
    }
    const prjData = props.data.prjDetails;
    const prjStartDate = prjData[0]?.estStartDate;
    const prjEndDate = prjData[0]?.estEndDate;
    const validColumnWidth = isNaN(columnWidth) ? 60 : columnWidth;
    const changeViewMode = (newViewMode) => {
        setViewMode(newViewMode);
    };
    
    function getMilestoneDetails() {
        let ids = `${props.data.tenantID}/${props.data.locationID}/${props.data.initiativeTypeID}/${props.data.projectID}`;
        if (props.data.tenantID) {
            dispatch(getMilestone(ids));
        }
    }
    useEffect(() => {
        getMilestoneDetails();
    }, [dispatch, props.data.tenantID]);
    useEffect(() => {
        if (milestoneInfo?.data) {
            setMileData(milestoneInfo?.data);
        }
    }, [milestoneInfo]);
    // useEffect(()=>{
    //     setMileData([])
    // },[props.data.tabKey])

    useEffect(()=>{
      setTasksData(mileData?.reduce((allTasks, milestone) => {
        // Add milestone task
        const milestoneTask = {
          id: `Milestone_${milestone?.mileStoneID}`,
          name: milestone?.mileStoneName,
          start:milestone?.startDate ? new Date(milestone?.startDate) :  new Date(prjStartDate),
          end: milestone?.endDate ? new Date(milestone?.endDate) :  new Date(prjEndDate),
          progress: milestone?.completePercentage?.compPercent,
          dependencies: [], 
          styles: {
            progressColor: '#7db59a',
            progressSelectedColor: '#628e78',
          },
          type:"project",
          parent: null, 
          hideChildren: false, 
        };
        allTasks.push(milestoneTask);
      
        // Add associated tasks
        if (milestone?.projectTaskList && milestone?.projectTaskList.length > 0) {
          milestone.projectTaskList.forEach((task, index) => {
            const taskItem = {
              id: `Task_${task?.pTaskID}`,
              name: task?.taskName,
              start:task?.estStartDate ? new Date(task?.estStartDate) :  new Date(prjStartDate),
              end: task?.estEndDate ? new Date(task?.estEndDate) :  new Date(prjEndDate),
              progress: 0, 
              dependencies: [`Milestone_${task?.mileStoneID}`] ,
              styles: {
              },
              parent: `Milestone_${milestone?.mileStoneID}`, 
              hideChildren: false, 
              type:"task",
              project:`Milestone_${task?.mileStoneID}`,
            };
      
            allTasks.push(taskItem);
          });
        }
        return allTasks;
      }, []))
    }, [mileData])

    const handleExpanderClick = (task) => {
      const updatedTasks = tasksData?.map((t) => (t.id === task.id ? task : t));
      setTasksData(updatedTasks)
    };
    return(
        <div className='gantt-chart'> 
            <div className='button-container d-flex justify-content-end p-3'>
                <button className={`ms-2 me-1 p-2 ps-3 pe-3 ${viewMode === ViewMode.Day ? 'selected' : ''}`} onClick={() => changeViewMode(ViewMode.Day)}>Day</button>
                <button className={`ms-2 me-1 p-2 ps-3 pe-3 ${viewMode === ViewMode.Week  ? 'selected' : ''}`} onClick={() => changeViewMode(ViewMode.Week)}>Week</button>
                <button className={`ms-2 me-1 p-2 ps-3 pe-3 ${viewMode === ViewMode.Month  ? 'selected' : ''}`} onClick={() => changeViewMode(ViewMode.Month)}>Month</button>
                <button className={`ms-2 p-2 ps-3 pe-3 ${viewMode === ViewMode.Year ? 'selected' : ''}`} onClick={() => changeViewMode(ViewMode.Year)}>Year</button>
            </div>
            <div className='p-3 pt-0'>
              {tasksData && tasksData.length > 0 && !loading7 ? (
                  <Gantt
                  tasks={tasksData}
                  viewMode={viewMode} 
                  columnWidth={validColumnWidth}
                  listCellWidth={"170px"}
                  onExpanderClick={handleExpanderClick}
                  // ganttHeight={300}
                  />
                  )
                  :
                  <Spin className='ganttLoad'></Spin>
              }
            </div>
        </div>
    )
}